import { render, staticRenderFns } from "./NoticeViewPage.vue?vue&type=template&id=7050065c"
import script from "./NoticeViewPage.vue?vue&type=script&lang=js"
export * from "./NoticeViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports